// ClickSound.js
import { useEffect } from "react";

export default function ClickSound({ soundSrc = "/click.mp3", enabled = true }) {
  useEffect(() => {
    if (!enabled) return;

    const audio = new Audio(soundSrc);
    audio.volume = 0.2;

    const handleClick = () => {
      audio.currentTime = 0; // restart if multiple clicks
      audio.play().catch(() => {}); // ignore play errors (autoplay restrictions)
    };

    document.addEventListener("click", handleClick);

    return () => document.removeEventListener("click", handleClick);
  }, [soundSrc, enabled]);

  return null;
}
